var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6879 9.28865C13.6879 6.72469 13.6879 4.16631 13.6879 1.60236C13.6879 1.1824 13.6021 1 13.1157 1C9.23665 1.0221 5.35749 1.0221 1.47839 1C1.02068 1 0.90625 1.16025 0.90625 1.55258C0.90625 6.65839 0.90625 11.7662 0.90625 16.8757C0.90625 17.3785 1.07227 17.5 1.57575 17.5C5.39001 17.5 9.21752 17.5 13.0585 17.5C13.5906 17.5 13.6993 17.3287 13.6936 16.8535C13.6765 14.3283 13.6879 11.8195 13.6879 9.28865Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0417 22.7578C31.0417 20.1871 31.0417 17.6109 31.0417 15.0347C31.0417 14.6044 30.9044 14.483 30.4696 14.483C26.6076 14.483 22.7457 14.483 18.8838 14.483C18.386 14.483 18.2601 14.6431 18.2658 15.0954C18.2658 20.1817 18.2658 25.266 18.2658 30.3486C18.2658 30.8395 18.4202 30.983 18.9294 30.983C22.7437 30.983 26.5714 30.983 30.4123 30.983C30.9387 30.983 31.0532 30.8119 31.0532 30.3375C31.0303 27.8109 31.0417 25.2844 31.0417 22.7578Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6898 1.01147C22.7789 1.01147 20.868 1.01147 18.9685 1.01147C18.4707 1.01147 18.2991 1.13742 18.3048 1.65806C18.3277 4.07631 18.3277 6.4926 18.3048 8.90702C18.3048 9.38762 18.4363 9.54216 18.9284 9.54216C22.7731 9.54216 26.6161 9.54216 30.4571 9.54216C30.9319 9.54216 31.0978 9.41624 31.092 8.9242C31.0692 6.49452 31.0692 4.06102 31.092 1.6237C31.092 1.1145 30.909 1.01148 30.4456 1.0172C28.4946 1.02292 26.5836 1.01147 24.6898 1.01147Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27883 30.9656C9.21266 30.9656 11.1407 30.9656 13.0745 30.9656C13.5094 30.9656 13.7039 30.8741 13.6982 30.3935C13.6753 27.9638 13.6753 25.5284 13.6982 23.0873C13.6982 22.6353 13.538 22.5151 13.1261 22.5151C9.26604 22.5151 5.40219 22.5151 1.53453 22.5151C1.0711 22.5151 0.928036 22.6697 0.933758 23.1274C0.933758 25.5303 0.933758 27.9332 0.933758 30.3362C0.933758 30.8626 1.11108 30.9885 1.60884 30.9828C3.47974 30.9657 5.37933 30.9656 7.27883 30.9656Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.24ff18dfe546a1e4bf76be41605ae338.svg";
export { ForwardRef as ReactComponent };